import {useSuspenseQuery} from '@tanstack/react-query';

import {api} from '@/lib/ky';

import {userSchema} from '../utils/schemas/user';

import {userKeys} from './queryKeys';

import type {
  ExtractFnReturnType,
  QueryConfig,
  QueryConfig2,
} from '@/lib/react-query';

export const getUser = async (id: string) => {
  const data = await api.get(`users/${id}`).json();
  return userSchema.parse(data);
};

export const useUser = (id: string, config?: QueryConfig<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: userKeys.detail(id),
    queryFn: () => getUser(id),
  });
};
export const useUserLoader = (config: QueryConfig2<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>(config);
};

type QueryFnType = typeof getUser;
